// extracted by mini-css-extract-plugin
export var headerCell = "_3y-1";
export var loadingSpinnerContainer = "_3y-4";
export var rowWrapper = "_3y-3";
export var standaloneTable = "_3y-5";
export var table = "_3y-0";
export var white = "_3y-2";